<template>
  <f7-popup id="popup-booking" class="popup-booking">
    <f7-view>
      <f7-page>
        <f7-block-title large>Upcoming сonsultation</f7-block-title>

        <f7-list class="booking-list" no-hairlines no-hairlines-between no-chevron>
          <f7-list-item
            v-for="item in $store.state.user.booking.filter(lesson =>
              isAfter(new Date(lesson.start), new Date())
            )"
            :key="item.id"
          >
            <BookingCard
              :id="item.id"
              :language-id="item.languageId"
              :level-id="item.levelId"
              :start="item.start"
              :name="''"
              :avatar="''"
            ></BookingCard>
          </f7-list-item>
        </f7-list>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { isAfter } from 'date-fns';
import BookingCard from '@/components/BookingCard.vue';

export default {
  name: 'PopupBooking',

  components: {
    BookingCard
  },

  computed: {
    isAfter: () => isAfter
  }
};
</script>

<style lang="scss">
#popup-booking.popup:not(.popup-tablet-fullscreen) {
  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 501px;
    --f7-popup-tablet-height: 565px;
  }
}
</style>
